import { useMemo } from 'react';

export const useDocumentWidth = () => {
  const documentWidth = document.body.clientWidth;
  return useMemo(() => documentWidth, [documentWidth]);
};
